import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import { HpRespPromoModulePromoItemOld } from './HpRespPromoModulePromoItemOld';
import { HpRespModuleContainerOld } from '../HpRespModuleContainerOld/HpRespModuleContainerOld';
import { trackPromoImpressions, trackPromoClick } from './helpers/PromoTrackingOld';
import { SharedInViewport } from '../../sharedComponents/SharedInViewport';

class HpRespPromoModuleSecondaryOldComponent extends Component {
    handleInitialDisplay = ({ inViewport }) => {
        const { componentModule, promoPrimaryItemsCount } = this.props;
        if (componentModule && inViewport) {
            const { items } = componentModule;

            trackPromoImpressions({
                items,
                startingIndex: promoPrimaryItemsCount,
            });
        }
    };

    render() {
        const { componentModule, promoPrimaryItemsCount, useLazyLoadImages } = this.props;
        if (!componentModule) {
            return null;
        }

        const { items } = componentModule;

        return (
            <HpRespModuleContainerOld addTopGap>
                <SharedInViewport stopWhenInViewport onInViewportChange={this.handleInitialDisplay}>
                    <div className="rowFlex">
                        {items.map((promotion, index) => (
                            <HpRespPromoModulePromoItemOld
                                key={promotion.cmsId}
                                promotion={promotion}
                                useLazyLoadImages={useLazyLoadImages}
                                className={items.length === 1 ? 'colXs12' : 'colLg6 colXs12'}
                                isFullBleedImage={promotion.isFullBleedImage && items.length === 1}
                                onClick={() =>
                                    trackPromoClick({
                                        item: promotion,
                                        index: index + promoPrimaryItemsCount,
                                    })
                                }
                            />
                        ))}
                    </div>
                </SharedInViewport>
            </HpRespModuleContainerOld>
        );
    }
}

HpRespPromoModuleSecondaryOldComponent.propTypes = {
    componentModule: PropTypes.object.isRequired,
    promoPrimaryItemsCount: PropTypes.number.isRequired,
    useLazyLoadImages: PropTypes.bool,
};

export const HpRespPromoModuleSecondaryOld = createFragmentContainer(
    HpRespPromoModuleSecondaryOldComponent,
    {
        componentModule: graphql`
            fragment HpRespPromoModuleSecondaryOld_componentModule on PromoModule {
                items {
                    cmsId
                    imageCopy
                    ... on PromoItem @skip(if: $isMobile) {
                        imageUrl
                        imageHeight
                        imageWidth
                    }
                    ... on PromoItem @include(if: $isMobile) {
                        mobileImageUrl
                        mobileImageHeight
                        mobileImageWidth
                    }
                    cta
                    linkData {
                        # path is used in PromoTrackingOld.js
                        path
                        ...SeoLink_linkData
                    }
                    isFullBleedImage
                }
            }
        `,
    }
);
